module.exports = __webpack_public_path__ + "static/media/angle-double-up.eb20e87e.svg";